import { render, staticRenderFns } from "./account-settings-security.vue?vue&type=template&id=31c25f16&scoped=true"
import script from "./account-settings-security.vue?vue&type=script&lang=js"
export * from "./account-settings-security.vue?vue&type=script&lang=js"
import style0 from "./account-settings-security.vue?vue&type=style&index=0&id=31c25f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c25f16",
  null
  
)

export default component.exports